import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';

import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { BreadcrumbService } from "src/app/services/breadcrumb";
@Component({
  selector: 'app-merchant-home',
  templateUrl: './merchant-home.component.html',
  styleUrls: ['./merchant-home.component.scss']
})
export class MerchantHomeComponent implements OnInit {
  breadcrumbItems: breadcrumbItem[] = [
    {
        label: 'Home',
        active: false,
        url: "/home",
    },
    {
      label: 'Merchant',
      active: true,
      url: "",
    },
  ]
  constructor(
    private BreadcrumbService: BreadcrumbService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.BreadcrumbService.setValue(this.breadcrumbItems);
  }
  activeClass() {
    const body = this.document.body;
    this.GetbodyClass(body);

    // this.className = sidemenu;
    // this.SetClassDetais(this.className)
    // localStorage.setItem('subMenuClass',this.className)
    // if (this.mainscreenWidth < 992) {
    //   this.classmenu = true;
    // }
  }

  GetbodyClass(bodyclass: any) {
    const body = this.renderer.selectRootElement("body", true);
    const bodyClasses = body.classList;
    const bodyClassesArray = Array.from(bodyClasses);
    if (bodyClassesArray[0] === "sidebar-enable") {
      bodyclass.classList.add("vertical-collpsed");
    }
  }


}
